export const HOME_FAQS = [
  { q: "I prezzi sono definitivi?", a: "Sì, quelli del listino, IVA esclusa. Ogni lavoro extra viene preventivato prima." },
  { q: "In quanto tempo è online?", a: "Di solito da una a quattro settimane dalla consegna di testi e foto, in base al pacchetto." },
  { q: "Il sito e il dominio sono miei?", a: "Il dominio è intestato a te. Sul sito ricevi i diritti concordati, nei limiti delle licenze usate." },
  { q: "Posso disdire?", a: "Start, Business e Premium con 30 giorni di preavviso. Digital Partner dopo il primo anno. Ti aiutiamo nel trasferimento." },
  { q: "Lavorate in tutta Italia?", a: "Sì, tutto online: videochiamate, email e WhatsApp. Milano, Como e Monza su appuntamento." },
];

export const PROCESS = [
  { n: "01", t: "Ci racconti la tua attività", d: "Videochiamata gratuita, 30 minuti." },
  { n: "02", t: "Analizziamo le esigenze", d: "Pacchetto, costi e tempi per iscritto." },
  { n: "03", t: "Progettiamo il tuo sito", d: "Vedi la grafica prima dello sviluppo." },
  { n: "04", t: "Lo sviluppiamo e lo pubblichiamo", d: "Test su ogni dispositivo, poi online." },
  { n: "05", t: "Ci occupiamo della gestione", d: "Aggiornamenti e backup: ci pensiamo noi." },
];

export const WHY = [
  { icon: "Receipt", t: "Prezzi trasparenti", d: "Listino pubblico, zero sorprese." },
  { icon: "Gem", t: "Qualità professionale", d: "Design curato e siti veloci." },
  { icon: "LifeBuoy", t: "Assistenza continuativa", d: "Ci siamo anche dopo." },
  { icon: "Sparkles", t: "Gestione semplificata", d: "Un solo referente per tutto." },
  { icon: "MapPin", t: "In tutta Italia", d: "Da remoto, da nord a sud." },
  { icon: "UserCheck", t: "Zero competenze tecniche", d: "Racconti, noi realizziamo." },
];

export const DEMOS = [
  { key: "bar", name: "Caffetteria", style: "Caldo e accogliente", pages: "Home, menu, galleria, orari, prenotazione" },
  { key: "parrucchieri", name: "Salone parrucchiere", style: "Elegante e raffinato", pages: "Trattamenti, listino, staff, appuntamento" },
  { key: "abbigliamento", name: "Boutique abbigliamento", style: "Editoriale contemporaneo", pages: "Collezioni, catalogo, schede prodotto" },
  { key: "botteghe", name: "Bottega", style: "Artigianale e moderno", pages: "Storia, prodotti, valori, galleria" },
  { key: "showroom", name: "Showroom arredamento", style: "Architettonico premium", pages: "Collezioni, materiali, realizzazioni" },
  { key: "artigiani", name: "Artigiano", style: "Professionale ed essenziale", pages: "Servizi, progetti, zone, sopralluogo" },
];
